<template>
<v-flex>
  <v-layout>
    <v-flex xs8>
      <v-text-field type="text" :label="`${index +1}) ${$t('schema.builder.inputs.table')}`" :value="data.name" :rules="nameRules" @change="update({name: $event})" />
    </v-flex>
    <v-flex xs1>
      <description :fieldName="data.name" :id="data.id" :description="data.description" @update="updateDescription($event)" @updateImages="updateOptions"></description>
    </v-flex>
    <v-flex xs1>
      <v-dialog width="90%" max-width="1000px" v-model="optionsDialog">
        <v-btn fab dark color="lime" slot="activator">
          <v-icon>table_chart</v-icon>
        </v-btn>
        <v-card>
          <v-card-title class="headline" primary-title>
            {{ $t('schema.builder.inputs.table') }}
          </v-card-title>
          <v-divider />
          <v-layout style="padding: 20px">
            <v-flex xs8>
              <draggable v-model="subFields">
                <div v-for="(data, index) in subFields" :key="data.id">
                  <component :is="subFieldComponent(data.type)" :key="data.id" :context="ContextClass.createTableContextWithParent(context,0, subFields)" :index="index" :data="data"></component>
                </div>
              </draggable>
            </v-flex>
            <v-flex xs3>
              <v-btn v-for="button in buttons" :key="button.type" block color="blue-grey darken-3" dark round
                     @click="appendSubField(button.type)">{{ button.label }}
              </v-btn>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn round color="primary" @click="optionsDialog = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
    <v-flex xs1>
      <v-btn fab dark color="warning" @click="tryToDestroy">
        <v-icon>delete_forever</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</v-flex>
</template>

<script>
import draggable from 'vuedraggable'
import SubField from './SubField'
import PredefinedSubField from './PredefinedSubField'
import fieldTypeEnum from '@/enums/fieldType'
import Description from './Description'
import field from '@/mixins/field'
import Context from '@/plugins/Context'

export default {
  components: {
    draggable,
    SubField,
    PredefinedSubField,
    Description
  },
  mixins: [field],
  props: ["data", "index"],
  data() {
    return {
      ContextClass: Context,
      optionsDialog: false,
      buttons: [{
        type: fieldTypeEnum.TEXT,
        label: this.$t('schema.builder.inputs.text-field')
      },
      {
        type: fieldTypeEnum.NUMBER,
        label: this.$t('schema.builder.inputs.number-field')
      },
      {
        type: fieldTypeEnum.DATE,
        label: this.$t('schema.builder.inputs.date-field')
      },
      {
        type: fieldTypeEnum.TIME,
        label: this.$t('schema.builder.inputs.time-field')
      },
      {
        type: fieldTypeEnum.RADIO,
        label: this.$t('schema.builder.inputs.radio-field')
      },
      {
        type: fieldTypeEnum.SIGNATURE,
        label: this.$t('schema.builder.inputs.signature-field')
      },
      {
        type: fieldTypeEnum.PHOTO,
        label: this.$t('schema.builder.inputs.photo-field')
      },
      {
        type: fieldTypeEnum.FORMULE,
        label: this.$t('schema.builder.inputs.formule-field')
      },
      {
        type: fieldTypeEnum.CODE,
        label: this.$t('schema.builder.inputs.code-field')
      },
      {
        type: fieldTypeEnum.MULTIPLE,
        label: this.$t('schema.builder.inputs.multiple-field')
      },
      {
        type: fieldTypeEnum.RELATED,
        label: this.$t('schema.builder.inputs.related-field')
      },
      {
        type: fieldTypeEnum.DEPEND,
        label: this.$t('schema.builder.inputs.select-depend-field')
      },
      {
        type: fieldTypeEnum.CHECKBOX,
        label: this.$t('schema.builder.inputs.checkbox-field')
      },
      {
        type: fieldTypeEnum.STORAGE,
        label: this.$t('schema.builder.inputs.storage-field')
      }

      ]
    }
  },
  computed: {
    subFields: {
      get() {
        return this.data["sub-fields"] || []
      },
      set(payload) {
        this.$store.commit('updateSubFields', {
          field_id: this.data.id,
          subFields: payload
        })
      }
    },
    type() {
      return fieldTypeEnum
    }
  },
  methods: {
    subFieldComponent(type) {
      if (fieldTypeEnum.predefined.includes(type)) {
        return 'predefined-sub-field'
      }
      return 'sub-field'
      
    },
    appendSubField(type) {
      let payload = {
        field_id: this.data.id,
        id: this.$uuid(),
        type,
        name: "",
        options: {}
      }
      if (fieldTypeEnum.predefined.includes(type)) {
        payload["values"] = []
      }
      this.$store.commit("appendSubField", payload)
    },
    tryToDestroy() {
      if (this.subFields.length > 0) {
        this.$confirm(this.$t('schema.builder.inputs.not-empty-table-delete'))
          .then(res => {
            if (res) {
              this.destroy()
            }
          })
      } else {
        this.destroy()
      }
    },
    update(payload) {
      payload['id'] = this.data.id
      this.$store.commit("updateField", payload)
    },
    destroy() {
      this.$store.commit("removeField", this.index)
    },
    updateDescription(description) {
      let payload = {
        id: this.data.id,
        description
      }
      this.$store.commit("updateFieldDescription", payload)
    },
    updateOptions(payload) {
      this.$store.commit("updateFieldOptions", payload)
    },
  },
}
</script>
